import React from 'react';
import Head from 'next/head';
import parse, { Element } from 'html-react-parser';
import { gql } from '@apollo/client';

import { useRouter } from 'next/router';
import Layout from '../../components/layout';
import Title from '../../components/title';
import { H1 } from '../../components/atoms/typography';
import { getYoastHeadSEO } from '../../lib/utils';
import { client, getPostByURI } from '../../apollo-client';

const About = ({ post }) => {
  const getPostContent = () => {
    let post_content = post.content.toString();

    post_content = post_content.replace(
      /\r\n<h3>/g,
      '<p style="margin:0;padding:0;">&nbsp;</p><h3>'
    );

    return post_content.replace(
      /\r\n<ul>/g,
      '<p style="margin:0;padding:0;">&nbsp;</p><ul>'
    );
  };

  const router = useRouter();
  const pathname = router.pathname;
  const yoastHead = getYoastHeadSEO(post?.seo?.fullHead, pathname);

  return (
    <>
      <Head>{yoastHead}</Head>

      <Title>About Us</Title>

      <Layout>
        <div className="article">
          <div className="relative bg-white pt-8 pb-20 px-4 sm:px-6 lg:pb-10 lg:px-8">
            <div className="relative max-w-7xl mx-auto pb-14">
              <article className="article">
                <div className="text-center">
                  <H1 className="text-center">About Us</H1>
                </div>
                <div className=" content-body mt-3 text-base text-gray-500">
                  {parse(getPostContent(), {
                    replace: (domNode: Element) => {
                      if (
                        domNode.attribs &&
                        domNode.attribs.class &&
                        domNode.attribs.class === 'epyt-video-wrapper'
                      ) {
                        // fixes double wrapping of iframe
                        domNode.attribs.class = '';

                        return { domNode };
                      }
                    }
                  })}
                </div>
              </article>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export const getStaticProps = async () => {
  const postQuery = await client.query({
    query: gql`
      ${getPostByURI('/about-us/')}
    `
  });

  const post = postQuery.data.postBy;

  return {
    props: { post }
  };
};

export default About;
